import { FC } from 'react';

export const LogoBlack: FC = () => {
  return (
    <svg
      width="148"
      height="38"
      viewBox="0 0 148 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M99.6981 35.5942C99.6981 36.0699 99.5568 36.535 99.2917 36.9306C99.0272 37.3262 98.6501 37.6346 98.2096 37.8167C97.7691 37.9989 97.284 38.0466 96.8157 37.9539C96.3481 37.8611 95.918 37.6321 95.5812 37.2958C95.2437 36.9595 95.0134 36.5309 94.9208 36.0643C94.8275 35.5978 94.8749 35.1141 95.0579 34.6746C95.2402 34.2351 95.5492 33.8594 95.9458 33.5951C96.3425 33.3308 96.8088 33.1897 97.2861 33.1897C97.9257 33.1897 98.5387 33.443 98.9911 33.8939C99.4434 34.3448 99.6981 34.9564 99.6981 35.5942Z"
        fill="#8C50FF"
        style={{
          fill: '#8C50FF',
          fillOpacity: 1,
        }}
      />
      <path
        d="M129.882 26.6699V14.0302H134.204L139.534 25.2853H138.392L143.678 14.0302H148V26.6699H145.268V14.9904H146.029L140.363 26.6699H137.519L131.853 15.0351L132.614 15.0127V26.6699H129.882Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M112.812 26.6699V14.0302H115.679V25.2183L114.805 25.0173L123.472 14.0302H127.235V26.6699H124.368V15.3254L125.264 15.5487L116.485 26.6699H112.812Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M95.6548 14.0301H98.5661V18.4295L98.4317 18.8761V21.4219L98.5661 22.2035V30.3546H95.6548V14.0301ZM97.4464 20.35C97.73 19.0101 98.2003 17.8489 98.8573 16.8663C99.5142 15.8688 100.32 15.0946 101.276 14.5438C102.246 13.9929 103.321 13.7175 104.501 13.7175C105.74 13.7175 106.837 14.0004 107.793 14.5661C108.748 15.1169 109.495 15.8911 110.032 16.8886C110.57 17.8712 110.839 19.025 110.839 20.35C110.839 21.6601 110.57 22.8139 110.032 23.8114C109.495 24.8089 108.748 25.5905 107.793 26.1562C106.837 26.7071 105.74 26.9825 104.501 26.9825C103.321 26.9825 102.254 26.7071 101.298 26.1562C100.343 25.6054 99.5291 24.8312 98.8573 23.8337C98.2003 22.8363 97.73 21.675 97.4464 20.35ZM107.882 20.35C107.882 19.5014 107.703 18.757 107.345 18.1168C107.002 17.4618 106.524 16.9556 105.912 16.5983C105.3 16.2261 104.598 16.04 103.807 16.04C103.015 16.04 102.269 16.2261 101.567 16.5983C100.88 16.9556 100.276 17.4618 99.7531 18.1168C99.2305 18.757 98.805 19.5014 98.4765 20.35C98.805 21.1986 99.2305 21.9504 99.7531 22.6055C100.276 23.2457 100.88 23.7519 101.567 24.1241C102.269 24.4814 103.015 24.66 103.807 24.66C104.598 24.66 105.3 24.4814 105.912 24.1241C106.524 23.7519 107.002 23.2457 107.345 22.6055C107.703 21.9504 107.882 21.1986 107.882 20.35Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M86.0098 26.9825C84.4721 26.9825 83.1209 26.7071 81.9563 26.1562C80.8067 25.5905 79.9035 24.8089 79.2465 23.8114C78.6046 22.8139 78.2836 21.6601 78.2836 20.35C78.2836 19.025 78.6046 17.8712 79.2465 16.8886C79.9035 15.8911 80.8067 15.1169 81.9563 14.5661C83.1209 14.0004 84.4721 13.7175 86.0098 13.7175C87.5476 13.7175 88.8913 14.0004 90.041 14.5661C91.2055 15.1169 92.1087 15.8911 92.7507 16.8886C93.4077 17.8712 93.7361 19.025 93.7361 20.35C93.7361 21.6601 93.4077 22.8139 92.7507 23.8114C92.1087 24.8089 91.2055 25.5905 90.041 26.1562C88.8913 26.7071 87.5476 26.9825 86.0098 26.9825ZM86.0098 24.7047C86.9952 24.7047 87.8388 24.526 88.5405 24.1687C89.2571 23.8114 89.8095 23.3127 90.1977 22.6725C90.5859 22.0174 90.78 21.2433 90.78 20.35C90.78 19.4567 90.5859 18.69 90.1977 18.0498C89.8095 17.3948 89.2571 16.8886 88.5405 16.5313C87.8388 16.174 86.9952 15.9953 86.0098 15.9953C85.0394 15.9953 84.1959 16.174 83.4792 16.5313C82.7626 16.8886 82.2102 17.3948 81.822 18.0498C81.4338 18.69 81.2397 19.4567 81.2397 20.35C81.2397 21.2433 81.4338 22.0174 81.822 22.6725C82.2102 23.3127 82.7626 23.8114 83.4792 24.1687C84.1959 24.526 85.0394 24.7047 86.0098 24.7047Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M63.192 26.6699L63.8415 20.35L63.192 14.0302H72.374C73.5982 14.0302 74.5538 14.313 75.2405 14.8788C75.9422 15.4445 76.2931 16.2261 76.2931 17.2236C76.2931 18.1466 75.9422 18.891 75.2405 19.4567C74.5538 20.0076 73.5908 20.3351 72.3516 20.4393L72.5755 19.9034C74.0387 19.9332 75.1584 20.2309 75.9348 20.7966C76.7111 21.3624 77.0993 22.1589 77.0993 23.1861C77.0993 24.2729 76.7037 25.129 75.9124 25.7543C75.136 26.3647 74.0536 26.6699 72.6651 26.6699H63.192ZM66.0138 25.9553L64.894 24.66H71.9261C72.7174 24.66 73.2847 24.5112 73.6281 24.2134C73.9864 23.9008 74.1656 23.469 74.1656 22.9182C74.1656 22.4269 73.964 22.0174 73.5609 21.6899C73.1727 21.3624 72.5158 21.1986 71.5901 21.1986H65.5211V19.3228H71.1646C71.9261 19.3228 72.4785 19.1739 72.8219 18.8761C73.1802 18.5635 73.3594 18.1615 73.3594 17.6702C73.3594 17.1938 73.2026 16.8067 72.8891 16.509C72.5905 16.1963 72.0828 16.04 71.3662 16.04H64.9164L66.0138 14.7671L66.6408 20.35L66.0138 25.9553Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M53.8378 26.9825C52.3 26.9825 50.9488 26.7071 49.7843 26.1562C48.6347 25.5905 47.7314 24.8089 47.0745 23.8114C46.4325 22.8139 46.1115 21.6601 46.1115 20.35C46.1115 19.025 46.4325 17.8712 47.0745 16.8886C47.7314 15.8911 48.6347 15.1169 49.7843 14.5661C50.9488 14.0004 52.3 13.7175 53.8378 13.7175C55.3756 13.7175 56.7193 14.0004 57.8689 14.5661C59.0334 15.1169 59.9367 15.8911 60.5787 16.8886C61.2356 17.8712 61.5641 19.025 61.5641 20.35C61.5641 21.6601 61.2356 22.8139 60.5787 23.8114C59.9367 24.8089 59.0334 25.5905 57.8689 26.1562C56.7193 26.7071 55.3756 26.9825 53.8378 26.9825ZM53.8378 24.7047C54.8232 24.7047 55.6667 24.526 56.3684 24.1687C57.085 23.8114 57.6375 23.3127 58.0256 22.6725C58.4138 22.0174 58.6079 21.2433 58.6079 20.35C58.6079 19.4567 58.4138 18.69 58.0256 18.0498C57.6375 17.3948 57.085 16.8886 56.3684 16.5313C55.6667 16.174 54.8232 15.9953 53.8378 15.9953C52.8673 15.9953 52.0238 16.174 51.3071 16.5313C50.5905 16.8886 50.0381 17.3948 49.6499 18.0498C49.2617 18.69 49.0676 19.4567 49.0676 20.35C49.0676 21.2433 49.2617 22.0174 49.6499 22.6725C50.0381 23.3127 50.5905 23.8114 51.3071 24.1687C52.0238 24.526 52.8673 24.7047 53.8378 24.7047Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M46.0017 14.0302V16.308H37.5588L38.9025 14.9681V26.6699H35.9911V14.0302H46.0017Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M26.3462 26.9825C24.8084 26.9825 23.4572 26.7071 22.2927 26.1562C21.1431 25.5905 20.2398 24.8089 19.5829 23.8114C18.9409 22.8139 18.6199 21.6601 18.6199 20.35C18.6199 19.025 18.9409 17.8712 19.5829 16.8886C20.2398 15.8911 21.1431 15.1169 22.2927 14.5661C23.4572 14.0004 24.8084 13.7175 26.3462 13.7175C27.884 13.7175 29.2277 14.0004 30.3773 14.5661C31.5418 15.1169 32.4451 15.8911 33.0871 16.8886C33.744 17.8712 34.0725 19.025 34.0725 20.35C34.0725 21.6601 33.744 22.8139 33.0871 23.8114C32.4451 24.8089 31.5418 25.5905 30.3773 26.1562C29.2277 26.7071 27.884 26.9825 26.3462 26.9825ZM26.3462 24.7047C27.3316 24.7047 28.1751 24.526 28.8768 24.1687C29.5935 23.8114 30.1459 23.3127 30.5341 22.6725C30.9222 22.0174 31.1163 21.2433 31.1163 20.35C31.1163 19.4567 30.9222 18.69 30.5341 18.0498C30.1459 17.3948 29.5935 16.8886 28.8768 16.5313C28.1751 16.174 27.3316 15.9953 26.3462 15.9953C25.3757 15.9953 24.5322 16.174 23.8155 16.5313C23.0989 16.8886 22.5465 17.3948 22.1583 18.0498C21.7701 18.69 21.576 19.4567 21.576 20.35C21.576 21.2433 21.7701 22.0174 22.1583 22.6725C22.5465 23.3127 23.0989 23.8114 23.8155 24.1687C24.5322 24.526 25.3757 24.7047 26.3462 24.7047Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M16.5275 9.92112V26.6699H13.5938V11.194L14.9375 12.5339H1.61244L2.95614 11.194V26.6699H0V9.92112H16.5275Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M147.043 2.04036H147.839V9.82772H147.043V6.30783H142.169V9.82772H141.389V2.04036H142.169V5.56024H147.043V2.04036Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M133.917 0.68535V6.10352e-05H137.869V0.68535H133.917ZM138.447 2.04035H139.134V9.82772H138.337V3.39535L133.371 9.82772H132.683V2.04035H133.464V8.47272L138.447 2.04035Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M129.644 2.04036H130.441V9.82773H129.644V8.06778C128.988 9.23589 127.786 9.99905 126.286 9.99905C124.069 9.99905 122.241 8.2391 122.241 5.93404C122.241 3.62898 124.069 1.86904 126.286 1.86904C127.786 1.86904 128.988 2.6322 129.644 3.8003V2.04036ZM126.349 9.25146C128.208 9.25146 129.644 7.78744 129.644 5.93404C129.644 4.08065 128.208 2.61663 126.349 2.61663C124.49 2.61663 123.038 4.08065 123.038 5.93404C123.038 7.78744 124.49 9.25146 126.349 9.25146Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M120.53 2.04036V9.82772H119.749V2.80352H115.813V6.55703C115.813 9.28261 114.657 9.93674 113.189 9.82772V9.09571C114.392 9.20473 115.032 8.56617 115.032 6.55703V2.04036H120.53Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M111.137 2.04036H111.934V9.82772H111.137V6.30783H106.264V9.82772H105.483V2.04036H106.264V5.56024H111.137V2.04036Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
      <path
        d="M99.6676 9.99904C97.3873 9.99904 95.5598 8.2391 95.5598 5.93404C95.5598 3.62898 97.3873 1.86903 99.6676 1.86903C101.932 1.86903 103.76 3.62898 103.76 5.93404C103.76 8.2391 101.932 9.99904 99.6676 9.99904ZM99.6676 9.25146C101.526 9.25146 102.963 7.78743 102.963 5.93404C102.963 4.08064 101.526 2.61662 99.6676 2.61662C97.809 2.61662 96.3564 4.08064 96.3564 5.93404C96.3564 7.78743 97.809 9.25146 99.6676 9.25146Z"
        fill="#1D2218"
        style={{
          fill: '#1D2218',
          fillOpacity: 1,
        }}
      />
    </svg>
  );
};
